import React from "react";

function Icon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="6"
            height="10"
            fill="none"
            viewBox="0 0 6 10"
        >
            <path
                fill="#58616D"
                fillOpacity="0.3"
                fillRule="evenodd"
                d="M1.06 0l4.531 4.53-4.53 4.53L0 8l3.47-3.47L0 1.06 1.06 0z"
                clipRule="evenodd"
            ></path>
        </svg>
    );
}

export default Icon;
